var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("strong", [_vm._v(_vm._s(_vm.rm.Title))]),
    _vm._v(" "),
    _c("div", [
      _vm.rm.HasValue
        ? _c("div", [
            _vm.rm.HasMultipleValues
              ? _c("div", [
                  _c(
                    "ul",
                    _vm._l(_vm.rm.ValuesAsArray, function (v) {
                      return _c("li", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(v) +
                            "\n                    "
                        ),
                      ])
                    }),
                    0
                  ),
                ])
              : _c("div", [_c("span", [_vm._v(_vm._s(_vm.rm.Value))])]),
          ])
        : _c("div", [
            _c("span", { staticClass: "text-muted font-italic" }, [
              _vm._v("Not provided"),
            ]),
          ]),
    ]),
    _vm._v(" "),
    _c("small", { staticClass: "text-muted" }, [
      _vm._v(_vm._s(_vm.rm.Description)),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }